import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2 } from 'lucide-react';
import { SectionHeading, CtaButton } from './Shared';
const stages = [{
  num: '01',
  title: 'Evaluación del insomnio',
  desc: 'Protocolo para detectar y evaluar el insomnio como problemática secundaria. Tipos de insomnio, factores desencadenantes, mantenimiento e impacto en la vida cotidiana del paciente.'
}, {
  num: '02',
  title: 'Conceptualización e integración al caso',
  desc: 'Sistema para integrar el insomnio al cuadro clínico del paciente y entender su relación con la problemática principal que trae a consulta.'
}, {
  num: '03',
  title: 'Plan de intervención',
  desc: 'Diseño del plan de trabajo para abordar el insomnio dentro del tratamiento. Objetivos, técnicas y tiempos estimados de intervención.'
}, {
  num: '04',
  title: 'Intervención cognitiva',
  desc: 'Protocolo para trabajar pensamientos, creencias, rumiación, ansiedad anticipatoria y patrones cognitivos que sostienen el insomnio.'
}, {
  num: '05',
  title: 'Intervención conductual',
  desc: 'Sistema de técnicas conductuales para el tratamiento del insomnio: control de estímulos, regulación de horarios, restricción del sueño con prudencia y técnicas de relajación.'
}, {
  num: '06',
  title: 'Seguimiento y cierre',
  desc: 'Sistema de monitoreo del sueño sesión a sesión, criterios de alta, prevención de recaídas y mantenimiento de los logros alcanzados.'
}];
export function Included() {
  return <section className="py-20 bg-navy text-white relative overflow-hidden" data-id="element-82">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-83"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-85">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-86">
            QUÉ INCLUYE KIT PSICOLOGÍA DEL INSOMNIO
          </h2>
          <p className="text-lg text-indigo-100" data-id="element-87">
            Todo lo que necesitás para detectar, intervenir y acompañar el
            insomnio en tus pacientes desde la evaluación inicial hasta el
            seguimiento y cierre del proceso.
          </p>
        </motion.div>

        {/* Main Guide Highlight */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-3xl p-8 md:p-10 mb-16 flex flex-col md:flex-row items-center gap-8" data-id="element-88">
          <div className="w-20 h-20 bg-gold/20 rounded-2xl flex items-center justify-center flex-shrink-0" data-id="element-89">
            <BookOpen className="w-10 h-10 text-gold" data-id="element-90" />
          </div>
          <div data-id="element-91">
            <h3 className="font-serif text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-92">
              Guía Principal: KIT Psicología del Insomnio
            </h3>
            <p className="text-indigo-100 text-lg leading-relaxed" data-id="element-93">
              El sistema completo para ordenar el abordaje psicológico del
              insomnio en pacientes que consultan por ansiedad, estrés,
              depresión, burnout, problemas vinculares, crisis vitales o
              malestar emocional general.
            </p>
          </div>
        </motion.div>

        {/* 6 Stages Grid */}
        <div className="mb-16" data-id="element-94">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-center mb-12 text-gold" data-id="element-95">
            Sistema Psicología del Insomnio™ en 6 etapas
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-96">
            {stages.map((stage, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-8 text-slate-800 shadow-xl relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-97">
                <div className="absolute -right-6 -top-6 text-8xl font-black text-slate-50 opacity-50 group-hover:scale-110 transition-transform duration-500" data-id="element-98">
                  {stage.num}
                </div>
                <div className="relative z-10" data-id="element-99">
                  <div className="text-gold font-bold text-xl mb-2" data-id="element-100">
                    {stage.num}
                  </div>
                  <h4 className="font-serif text-xl font-bold text-navy mb-4 pr-4" data-id="element-101">
                    {stage.title}
                  </h4>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-102">
                    {stage.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-103">
          <CtaButton className="px-12 py-5 text-xl" data-id="element-104">
            SÍ, QUIERO EL KIT AHORA
          </CtaButton>
        </div>
      </div>
    </section>;
}